/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
import { __assign } from "tslib";
import * as msRest from "@azure/ms-rest-js";
import * as Mappers from "../models/labOperationsMappers";
import * as Parameters from "../models/parameters";
/** Class representing a LabOperations. */
var LabOperations = /** @class */function () {
  /**
   * Create a LabOperations.
   * @param {LabsApiClientContext} client Reference to the service client.
   */
  function LabOperations(client) {
    this.client = client;
  }
  LabOperations.prototype.getMetadata = function (region, resourceGroupName, labName, options, callback) {
    return this.client.sendOperationRequest({
      region: region,
      resourceGroupName: resourceGroupName,
      labName: labName,
      options: options
    }, getMetadataOperationSpec, callback);
  };
  LabOperations.prototype.getMetadata1 = function (resourceGroupName, labName, options, callback) {
    return this.client.sendOperationRequest({
      resourceGroupName: resourceGroupName,
      labName: labName,
      options: options
    }, getMetadata1OperationSpec, callback);
  };
  LabOperations.prototype.labPlanPut = function (body, region, resourceGroupName, labName, options, callback) {
    return this.client.sendOperationRequest({
      body: body,
      region: region,
      resourceGroupName: resourceGroupName,
      labName: labName,
      options: options
    }, labPlanPutOperationSpec, callback);
  };
  LabOperations.prototype.labPlanPut1 = function (body, resourceGroupName, labName, options, callback) {
    return this.client.sendOperationRequest({
      body: body,
      resourceGroupName: resourceGroupName,
      labName: labName,
      options: options
    }, labPlanPut1OperationSpec, callback);
  };
  LabOperations.prototype.publish = function (region, resourceGroupName, labName, options, callback) {
    return this.client.sendOperationRequest({
      region: region,
      resourceGroupName: resourceGroupName,
      labName: labName,
      options: options
    }, publishOperationSpec, callback);
  };
  LabOperations.prototype.publish1 = function (resourceGroupName, labName, options, callback) {
    return this.client.sendOperationRequest({
      resourceGroupName: resourceGroupName,
      labName: labName,
      options: options
    }, publish1OperationSpec, callback);
  };
  return LabOperations;
}();
export { LabOperations };
// Operation Specifications
var serializer = new msRest.Serializer(Mappers);
var getMetadataOperationSpec = {
  httpMethod: "GET",
  path: "{region}/api/subscriptions/{subscriptionId}/resourceGroups/{resourceGroupName}/labs/{labName}/metadata",
  urlParameters: [Parameters.region, Parameters.subscriptionId, Parameters.resourceGroupName, Parameters.labName],
  queryParameters: [Parameters.apiVersion],
  headerParameters: [Parameters.acceptLanguage],
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Dictionary",
          value: {
            type: {
              name: "String"
            }
          }
        }
      }
    },
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};
var getMetadata1OperationSpec = {
  httpMethod: "GET",
  path: "api/subscriptions/{subscriptionId}/resourceGroups/{resourceGroupName}/labs/{labName}/metadata",
  urlParameters: [Parameters.subscriptionId, Parameters.resourceGroupName, Parameters.labName],
  queryParameters: [Parameters.apiVersion],
  headerParameters: [Parameters.acceptLanguage],
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Dictionary",
          value: {
            type: {
              name: "String"
            }
          }
        }
      }
    },
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};
var labPlanPutOperationSpec = {
  httpMethod: "PUT",
  path: "{region}/api/subscriptions/{subscriptionId}/resourceGroups/{resourceGroupName}/labs/{labName}",
  urlParameters: [Parameters.region, Parameters.subscriptionId, Parameters.resourceGroupName, Parameters.labName],
  queryParameters: [Parameters.apiVersion],
  headerParameters: [Parameters.acceptLanguage],
  requestBody: {
    parameterPath: "body",
    mapper: __assign(__assign({}, Mappers.CreateLab), {
      required: true
    })
  },
  responses: {
    200: {
      bodyMapper: Mappers.CreateLab
    },
    201: {
      bodyMapper: Mappers.CreateLab
    },
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};
var labPlanPut1OperationSpec = {
  httpMethod: "PUT",
  path: "api/subscriptions/{subscriptionId}/resourceGroups/{resourceGroupName}/labs/{labName}",
  urlParameters: [Parameters.subscriptionId, Parameters.resourceGroupName, Parameters.labName],
  queryParameters: [Parameters.apiVersion],
  headerParameters: [Parameters.acceptLanguage],
  requestBody: {
    parameterPath: "body",
    mapper: __assign(__assign({}, Mappers.CreateLab), {
      required: true
    })
  },
  responses: {
    200: {
      bodyMapper: Mappers.CreateLab
    },
    201: {
      bodyMapper: Mappers.CreateLab
    },
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};
var publishOperationSpec = {
  httpMethod: "POST",
  path: "{region}/api/subscriptions/{subscriptionId}/resourceGroups/{resourceGroupName}/labs/{labName}/publish",
  urlParameters: [Parameters.region, Parameters.subscriptionId, Parameters.resourceGroupName, Parameters.labName],
  queryParameters: [Parameters.apiVersion],
  headerParameters: [Parameters.acceptLanguage],
  requestBody: {
    parameterPath: {
      capacity: ["options", "capacity"]
    },
    mapper: __assign(__assign({}, Mappers.PublishLab), {
      required: true
    })
  },
  responses: {
    200: {},
    202: {},
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};
var publish1OperationSpec = {
  httpMethod: "POST",
  path: "api/subscriptions/{subscriptionId}/resourceGroups/{resourceGroupName}/labs/{labName}/publish",
  urlParameters: [Parameters.subscriptionId, Parameters.resourceGroupName, Parameters.labName],
  queryParameters: [Parameters.apiVersion],
  headerParameters: [Parameters.acceptLanguage],
  requestBody: {
    parameterPath: {
      capacity: ["options", "capacity"]
    },
    mapper: __assign(__assign({}, Mappers.PublishLab), {
      required: true
    })
  },
  responses: {
    200: {},
    202: {},
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};